<template>
  <div>
    <div class="vx-row">
      <vx-card v-if="!is_on_create" v-can="'view-order'" titleIcon="FilterIcon" ref="filterCard" title="Advanced Filters" class="user-list-filters mb-8" :collapse-action="true" id="customer_orders_list_filters">
        <div class="vx-row">
          <div class="vx-col w-1/5 ml-0">
            <label class="text-sm opacity-100 text-bold">Order Item Status</label>
            <v-select  :clearable="true" placeholder=""  v-model="filters['status']"
                         :options="status_list" :reduce="option => option.value" label="name"
                         :dir="$vs.rtl ? 'rtl' : 'ltr'" multiple></v-select>
          </div>
          <div class="vx-col md:w-1/5 sm:w-1/2 w-full">
              <label class="text-sm opacity-100 text-bold">Order Date From</label>
              <flat-pickr style="display: none"
                          class="w-full"
                          :config="{ dateFormat: 'd/m/Y'}"
                          v-model="filters['date-from']"
                          placeholder="Choose Date"
              />
              <flat-pickr
                class="w-full"
                :config="{ dateFormat: 'd/m/Y'}"
                v-model="filters['date-from']"
                placeholder="Choose Date"
              />
          </div>
          <div class="vx-col md:w-1/5 sm:w-1/2 w-full">
              <label class="text-sm opacity-100 text-bold">Order Date To</label>
              <flat-pickr style="display: none"
                          class="w-full"
                          :config="{ dateFormat: 'd/m/Y'}"
                          v-model="filters['date-to']"
                          placeholder="Choose Date"
              />
              <flat-pickr
                class="w-full"
                :config="{ dateFormat: 'd/m/Y'}"
                v-model="filters['date-to']"
                placeholder="Choose Date"
              />
          </div>
        </div>
      </vx-card>
    </div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <vx-card v-can="'view-order'" v-if="!is_on_create" title="PRODUCT ORDERS" >
          <template slot="actions">
            <vs-button v-can="'create-order'" @click="onClickCreateNewOrder" class="mr-4" color="primary" type="filled">Create new order</vs-button>
          </template>
          <div slot="no-body" class="mt-4">
            <vs-table :max-items="(meta.per_page) ? meta.per_page : 10" :data="staff" @sort="handleSort"   :sst="true" stripe class="table-dark-inverted table-auto vs-con-loading__container">>
              <template slot="header">
                  <vs-input icon-pack="feather" icon="icon-search" placeholder="Search"
                            v-model="filters['search']"
                            class="is-label-placeholder px-3 pb-5 w-full md:w-1/3 xl:w-1/7 rounded-full" />
                <vs-chip v-if="!!creditDetails" class="ml-0 mr-2" style="border-radius: 0" transparent color="danger">
                  <span class="font-semibold">Current credit amount :</span> {{__accountCurrency()}} {{creditDetails.current_credit_amount}}
                </vs-chip>
                <vs-chip v-if="!!creditDetails" class="mr-auto ml-0" style="border-radius: 0" transparent color="danger">
                  <span class="font-semibold">Remaining credit :</span> {{__accountCurrency()}} {{creditDetails.available_credit}}
                </vs-chip>
              </template>
              <template slot="thead">
                <vs-th width="15%" sort-key="created_at">DATE/TIME</vs-th>
                <!-- <vs-th width="15%" sort-key="created_at">PLACED BY</vs-th> -->
                <vs-th width="10%" sort-key="sample_order_code">ORDER CODE</vs-th>
                <vs-th width="30%" >FINISHED PRODUCTS</vs-th>
               <vs-th width="15%" >STATUS</vs-th>
                <vs-th width="15%" class="justify-end ml-auto mr-0" >ORDER VALUE Excl VAT/Tax in {{__accountCurrency()}}</vs-th>
                <vs-th width="15%" class="" >ACTION</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr @click.native="onClickOrderDetailsView(data[indextr].id)" style="cursor: pointer"  :key="indextr" v-for="(tr, indextr) in data">


                  <vs-td :data="data[indextr].created_at">
                    {{__dateTimeFormatter(data[indextr].created_at)}}
                  </vs-td>

                  <!-- <vs-td :data="data[indextr].created_by">
                    {{ data[indextr].created_by}}
                  </vs-td> -->

                  <vs-td :data="data[indextr].product_order_code">
                    {{ data[indextr].product_order_code}}
                  </vs-td>

                  <vs-td :data="data[indextr].formulations">
                    <span v-if="data[indextr].formulation_items.length > 0" v-for="item in data[indextr].formulation_items" :key="item.id">
                      <span>{{ item.formulation_code }}</span> ,
                    </span>
                  </vs-td>

                  <vs-td>
                    <vs-chip style="border-radius: 0;">
                      {{ salesOrderStatusFactory(data[indextr].formulation_items) }}
                    </vs-chip>
                  </vs-td>

                  <vs-td class="flex justify-end mr-4">
                    {{ totalCalculator(data[indextr].formulation_items)}}
                  </vs-td>

                  <vs-td>
                    <div class="vx-row">
                      <vx-tooltip class="mr-2" text="View Order" position="left">
                        <vs-button @click.stop="onClickOrderDetailsView(data[indextr].id)"
                                   size="small" color="primary" type="border" icon-pack="feather" icon="icon-eye"></vs-button>
                      </vx-tooltip>
                      <vx-tooltip v-can="'edit-order'" v-if="data[indextr].status.id <= 2" class="mr-2" text="Update Order" position="left">
                        <vs-button @click.native="onClickProductOrderUpdate(data[indextr].id)"
                                   size="small" color="warning" type="border" icon-pack="feather" icon="icon-edit"></vs-button>
                      </vx-tooltip>

                    </div>
                  </vs-td>

                  <!-- <template class="expand-user" slot="expand">
                    <div class="con-expand-users w-full">
                      <div class="con-btns-user flex items-center justify-between">
                        <div class="con-userx flex items-center justify-start">
                        </div>
                        <div class="flex mb-4">
                          <vs-button v-if="[1].includes(tr.status.id)" @click="onClickStatusChangeConfirm(tr.id, 'cancel')" type="border" size="small" icon-pack="feather" icon="icon-x" color="danger" class="mr-2">Cancel Order</vs-button>
                        </div>
                      </div>

                      <div class="vx-row mb-1">
                        <div class="vx-col md:w-1/3 w-full md:mb-0">
                          <vs-list>
                            <vs-list-header title="Address"></vs-list-header>

                            <vs-list-item subtitle="Address Line 1" :title="tr.line1 ? tr.line1 : '-'"></vs-list-item>
                            <vs-list-item subtitle="Address Line 2" :title="tr.line2 ? tr.line2 : '-'"></vs-list-item>
                            <vs-list-item subtitle="Address Line 3" :title="tr.line3 ? tr.line3 : '-'"></vs-list-item>
                            <vs-list-item subtitle="Town/State" :title="tr.town_state ? tr.town_state : '-'"></vs-list-item>
                            <vs-list-item subtitle="Postal Code" :title="tr.post_code ? tr.post_code: '-'"></vs-list-item>
                            <vs-list-item subtitle="Country" :title="tr.country ? tr.country : '-'"></vs-list-item>

                            <vs-list-header title="Special Delivery Instructions"></vs-list-header>

                            <vs-list-item :subtitle="tr.delivery_instruction ? tr.delivery_instruction : '-'"></vs-list-item>
                          </vs-list>
                        </div>
                        <div class="vx-col md:w-2/3 w-full md:mb-0">
                          <vs-list-header title="Finished products"></vs-list-header>
                          <product-order-table
                            v-on:refresh="refreshData"
                            v-bind:id="data[indextr].id"
                            v-bind:status_id="data[indextr].status.id"
                            v-bind:creditDetails="creditDetails"
                            v-bind:items="data[indextr].formulation_items"/>
                        </div>
                      </div>

                    </div>
                  </template> -->

                </vs-tr>
                <!-- <vs-tr>
                  <vs-td></vs-td>
                  <vs-td style="font-weight: bolder">Total order value ({{__accountCurrency()}})</vs-td>
                  <vs-td></vs-td>
                  <vs-td></vs-td>
                  <vs-td></vs-td>
                  <vs-td></vs-td>
                  <vs-td class="flex mr-4 justify-end" style="font-weight: bolder">{{totalOrderValuePending()}}</vs-td>
                  <vs-td></vs-td>

                </vs-tr> -->
              </template>


            </vs-table>
            <vs-pagination :total="(meta.last_page)? meta.last_page : 0" v-model="page"  class="p-5"></vs-pagination>

          </div>
        </vx-card>
        <customer-cart-list v-on:back="refreshData($event)" v-if="is_on_create"/>
      </div>
    </div>
    <update-customer-product-order-pop-up ref="updateCustomerProductOrderPopUp"/>
  </div>
</template>

<script>
  import vSelect from 'vue-select'
  import {RepositoryFactory} from '@/repository/RepositoryFactory'
  import Filter from '@/mixins/filter';
  import UpdateCustomerProductOrderPopUp
    from '@/components/popups/customer/product-orders/UpdateCustomerProductOrderPopUp'
  import CustomerCartList from './CustomerCartList'
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  import ProductOrderTable from './ProductOrderTable'

  const CustomerRepository = RepositoryFactory.get('customer')
  import {product_order_statuses} from '@/constants/statuses'
  import flatPickr from "vue-flatpickr-component";
  import 'flatpickr/dist/flatpickr.css'

  export default {
    name: 'AllUsersList',
    data () {
      return {
        staff: [],
        filters: {},
        page : 1,
        total: 0,
        meta : {},
        sort : '',
        is_on_create: false,
        creditDetails: {},
        product_order_statuses: product_order_statuses,
        status_list: [
          { name: 'Submitted', value: 'Submitted' },
          { name: 'Accepted', value: 'Pending' },
          { name: 'In-Manufacturing', value: 'In-Manufacturing' },
          { name: 'In-QC', value: 'In-QC' },
          { name: 'In-Dispatch', value: 'In-Dispatch' },
          { name: 'Dispatched', value: 'Dispatched' },
          { name: 'Customer-Received', value: 'Customer-Received' },
          { name: 'Returned', value: 'Returned' },
          { name: 'Part Returned', value: 'Part Returned' },
          { name: 'Goods-Lost', value: 'Goods-Lost' },
          { name: 'Rejected/Cancelled', value: 'Cancelled' },
        ],
      }
    },
    components: {
      'v-select': vSelect,
      UpdateCustomerProductOrderPopUp,
      CustomerCartList,
      ProductOrderTable,
      flatPickr
    },
    mixins : [Filter, SuccessMessage, ErrorMessages],
    async mounted () {
      await this.getCreditDetails()
    },
    methods: {
      async refreshData () {
        this.is_on_create = false
        this.getProductOrderList()
      },
      async getCreditDetails() {
        try {
          const {data} = await CustomerRepository.getCustomerAccountCredit()
          this.creditDetails = data.data
        } catch (e) {
        }
      },
      async onClickOrderDetailsView (id) {
        this.$router.push({path: `/pages/customer-product-orders/${id}`})
      },

      async getProductOrderList() {
        this.$vs.loading()
        try {
          const {data} = await CustomerRepository.getListOfProductOrders(this.page, this.filterQuery, 10, this.sort)
          this.staff =  data.data
          this.meta = data.meta
        } catch (error) {
          this.convertAndNotifyError(error)
        }
        this.$vs.loading.close()
      },

      async onClickProductOrderUpdate (id) {
        await this.$refs.updateCustomerProductOrderPopUp.openPopup(id)
      },
      onClickCreateNewOrder() {
        this.is_on_create = true
      },

      filterQueryUpdate (){
        this.getProductOrderList()
      },

      handleChangePage(page) {
        this.page=page;
        this.getProductOrderList()
      },
      handleSort(key, active) {
        if(key){
          active = (active==='desc')? "-":'';
          this.sort=active+key;
          this.getProductOrderList()
        }
      },
      ProductOrderStatusColorFactory(status_name) {
        const status = this.product_order_statuses.find((n) =>  n.name === status_name)
        return status ? status.color : 'dark'
      },
      onClickFormula(id) {
        // this.$router.push({path: `/pages/formulations/${id}`})
      },
      onClickStatusChangeConfirm(id, status) {
        this.$vs.dialog({
          type: 'confirm',
          color: 'primary',
          title: 'Confirm',
          text: 'Are you sure you want to make this change?',
          accept: this.onChangeSampleOrderStatus,
          parameters: [id, status]
        })
      },
      async onChangeSampleOrderStatus(params){
        this.$vs.loading()
        try {
          await CustomerRepository.statusChangeCustomerProductOrders(params[0], params[1])
          this.showSuccessMessage('Status change successfully!')
          await this.getProductOrderList()
        }catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close()
      },
      totalCalculator(data) {
        // data.forEach((m) => {
        //   if (!!m.price) {
        //     total = total + Number(m.price) * Number(m.quantity)
        //   }
        //
        // })
        const total =  data.reduce((acc, obj) => {return acc + Number(obj.price) * Number(obj.quantity)}, 0)
        return total.toFixed(2)
      },
      totalOrderValuePending() {
        // let total = 0
        // this.staff.forEach((m) => {
        //   const sub_total = this.totalCalculator(m.formulation_items)
        //   total = Number(total) + Number(sub_total)
        // })
        //
        //

        const total = this.staff.reduce((acc, obj) => {
          return acc + Number(this.totalCalculator(obj.formulation_items))
        }, 0)

        return (Number(total)).toFixed(2)
      },
      salesOrderStatusFactory(items) {
        const firstItemStatus = items[0].item_status;
        const allItemsHaveSameStatus = items.every(item => item.item_status === firstItemStatus);
        return (items.length === 1 && firstItemStatus === 'Pending') ? 'Accepted' : (allItemsHaveSameStatus ? (firstItemStatus === 'Pending' ? 'Accepted' : firstItemStatus) : 'Multiple Items');
      }

    },
    watch : {
      page(){
        this.getProductOrderList()
      }
    }
  }
</script>


<style scoped>
  table td {
    vertical-align: top;
    min-width: 140px;
    padding-bottom: .8rem;
    word-break: break-all;
    }

</style>
